// utils/appEnv.js - Vue2适配版
// 环境监测 - APP环境

// 判断是否为APP环境（uni-app）
export const isAppEnvironment = () => {

  // 容错：非浏览器环境（如APP原生端）无navigator，直接返回false
  if (!window || !window.navigator) {
    return false;
  }
  const userAgent = window.navigator.userAgent.toLowerCase();
  // 核心判断：匹配uni-app相关标识（兼容不同端的uni-app web-view）
  const isYntsApp = /uni-app/.test(userAgent) || /uinavigationbar/.test(userAgent) || userAgent.includes('html5plus');

  return isYntsApp;
}

// 发送消息到APP
/**
 * @param {string} action - 动作名称
 * @param {string} type - 消息类型（message/data/instruct）
 * @param {any} message - 消息内容
 * 
 * type枚举：
 * 1. message(普通消息) - callOut(叫号消息)
 * 2. data(数据) - cache_data(缓存数据)
 * 3. instruct(指令) - app_close/ app_toConfig
 */
export const postMessageToApp = (action, type, message) => {
  if (isAppEnvironment()) {
    const data = window.uni.postMessage({
      data: {
        action: action,
        message: {
          type: type,
          message: message
        }
      }
    });
    console.log('消息发送到APP成功', JSON.stringify(data));
    return data; // 增加返回值，方便调用方判断结果
  } else {
    console.warn('当前环境不是APP，无法发送消息');
    return null; // 统一返回格式
  }
}

// 挂载到Vue原型的安装方法（Vue2全局使用）
export const install = (Vue) => {
  // 组件中可通过 this.$isAppEnvironment() 调用
  Vue.prototype.$isAppEnvironment = isAppEnvironment;
  // 组件中可通过 this.$postMessageToApp() 调用
  Vue.prototype.$postMessageToApp = postMessageToApp;
}